import { useState } from "react";
import { PiGhostBold } from "react-icons/pi";

import styles from "./WelcomeMessage.module.scss";

const SERVICENOW_AI_POLICY_URL =
  "https://vylor.service-now.com/sp?id=kb_article_view&sysparm_article=KB0042887&sys_kb_id=5f2694b9337ff610213535a9ed5c7b1e";

interface SecurityPrivacyProps {
  incognito?: boolean;
}

export default function SecurityPrivacy({
  incognito = false,
}: SecurityPrivacyProps) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className={`pa3 mb3 br2 ${styles.securityPrivacy}`}>
      <button
        className={styles.securityToggle}
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-label={
          isCollapsed ? "Expand security info" : "Collapse security info"
        }
        aria-expanded={!isCollapsed}
      >
        <span className={styles.toggleArrow}>{isCollapsed ? "▶" : "▼"}</span>
        <span className="b">Security & Privacy</span>
      </button>
      {!isCollapsed && (
        <ul className={`${styles.securityList} mt2 pl3`}>
          {incognito ? (
            <>
              <li>
                Messages are not saved by Vylor or third-party companies, and
                are not used for model training purposes
              </li>
              <li>
                Gemini web search queries are logged by Google like traditional
                Google searches: &nbsp;
                <a
                  href="https://ai.google.dev/gemini-api/terms#data-collection"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gemini Terms of Service
                </a>
              </li>
              <li>
                Please follow data classification guidelines - at this time,
                sending data classified as &quot;Special Control&quot; is
                strictly prohibited
              </li>
              <li>
                <a
                  href={SERVICENOW_AI_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Vylor Global Cybersecurity Responsible Use Policy
                </a>
              </li>
            </>
          ) : (
            <>
              <li>
                Messages and uploaded files never leave the Vylor tenant, are
                not saved by third-party companies or used for model training
                purposes
              </li>
              <li>
                Gemini web search queries are logged by Google like traditional
                Google searches: &nbsp;
                <a
                  href="https://ai.google.dev/gemini-api/terms#data-collection"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gemini Terms of Service
                </a>
              </li>
              <li>
                Chat messages and uploaded files will be stored in a secure
                centralized location, a user may permanently delete their own
                chat history or uploaded files at any time
              </li>
              <li>
                For sensitive conversations, we recommend using the Incognito
                Chat{" "}
                <PiGhostBold
                  style={{
                    verticalAlign: "middle",
                    marginLeft: "0.2rem",
                  }}
                />{" "}
                feature, where neither messages nor uploaded files are stored
              </li>
              <li>
                Please follow data classification guidelines - at this time,
                sending data classified as &quot;Special Control&quot; is
                strictly prohibited
              </li>
              <li>
                <a
                  href={SERVICENOW_AI_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Vylor Global Cybersecurity Responsible Use Policy
                </a>
              </li>
            </>
          )}
        </ul>
      )}
    </div>
  );
}
